import { Box, Button, TextButton } from '@wix/design-system';
import type { SyntheticEvent } from 'react';
import React from 'react';

import type { TFunction } from './../../../ricos-types/commonTypes';
import { useBiNext } from './../../bi-context-provider/bi-context-provider';

import { LINK_MODAL_ID } from '../constants';
import { CANCEL_BUTTON, SAVE_BUTTON, UNLINK_BUTTON } from '../data-hooks/data-hooks';

type Props = {
  onClickCancel: () => void;
  onClickSave: React.EventHandler<SyntheticEvent>;
  onClickUnlink?: () => void;
  showUnlink?: boolean;
  t: TFunction;
};

export const Footer: React.FC<Props> = ({
  onClickCancel,
  onClickSave,
  onClickUnlink,
  showUnlink,
  t,
}) => {
  const logBi = useBiNext({ pluginId: 'link', modalId: LINK_MODAL_ID });

  const onClickCancelAndLog = () => {
    onClickCancel();
    logBi({ dataHook: CANCEL_BUTTON });
  };

  const onClickSaveAndLog = (evt: SyntheticEvent) => {
    onClickSave(evt);
    // We don't log BI event here because there is a log on submit
  };

  const onClickUnlinkAndLog = () => {
    if (onClickUnlink) {
      onClickUnlink();
      logBi({ dataHook: UNLINK_BUTTON });
    }
  };

  return (
    <Box align="space-between" gap="SP2" verticalAlign="middle">
      <Box>
        {showUnlink && (
          <TextButton
            dataHook={UNLINK_BUTTON}
            onClick={onClickUnlinkAndLog}
            size="small"
            underline="always"
          >
            {t('LinkSettings_Action_Unlink')}
          </TextButton>
        )}
      </Box>
      <Box align="right" gap="SP2">
        <Button
          dataHook={CANCEL_BUTTON}
          onClick={onClickCancelAndLog}
          priority="secondary"
          size="small"
        >
          {t('LinkSettings_Action_Cancel')}
        </Button>
        <Button dataHook={SAVE_BUTTON} onClick={onClickSaveAndLog} size="small">
          {t('LinkSettings_Action_Save')}
        </Button>
      </Box>
    </Box>
  );
};
